var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 28,
    viewBox: "0 0 137 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.853 21.3822H48.9335L43.4216 6.85457H39.5119L34 21.3822H37.8883L38.7428 18.8185H43.9984L44.853 21.3822ZM39.811 15.6566L41.3706 10.9778L42.9302 15.6566H39.811Z",
    fill: "#0D2259"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5173 6V10.6787H53.0136L49.9799 13.7124V19.0962L52.2658 21.3822H55.2141L56.9018 19.6944L56.9446 21.3822H60.1492V6H56.5173ZM54.4236 18.4766L53.6118 17.6648V14.802L54.8295 13.5843H56.5173V17.4939L55.5345 18.4766H54.4236Z",
    fill: "#0D2259"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7493 10.6787H73.7156L72.0919 12.3024L70.4468 10.6787H67.3918L65.704 12.3665L65.6613 10.6787H62.4567V21.3822H66.0886V14.567L67.0713 13.5843H68.2891L68.7591 14.0543V21.3822H72.391V14.5884L73.3951 13.5843H74.5915L75.0615 14.0543V21.3822H78.6934V12.6229L76.7493 10.6787Z",
    fill: "#0D2259"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8482 9.0337H84.4801V6H80.8482V9.0337ZM80.8482 21.3822H84.4801V10.6787H80.8482V21.3822Z",
    fill: "#0D2259"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5608 14.9729L90.2666 14.7166L90.0316 14.4816V13.6484L90.3307 13.3493H92.7448L93.8771 14.4816L96.0349 12.3238L94.3898 10.6787H88.1943L86.3997 12.4733V15.4429L88.0447 17.088L92.3389 17.3443L92.5739 17.5794V18.4125L92.2748 18.7116H89.3906L88.1729 17.4939L86.0151 19.6517L87.7456 21.3822H94.4112L96.2058 19.5876V16.618L94.5608 14.9729Z",
    fill: "#0D2259"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.692 14.9729L101.398 14.7166L101.163 14.4816V13.6484L101.462 13.3493H103.876L105.008 14.4816L107.166 12.3238L105.521 10.6787H99.3253L97.5307 12.4733V15.4429L99.1757 17.088L103.47 17.3443L103.705 17.5794V18.4125L103.406 18.7116H100.522L99.3039 17.4939L97.1461 19.6517L98.8766 21.3822H105.542L107.337 19.5876V16.618L105.692 14.9729Z",
    fill: "#0D2259"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.046 9.0337H112.678V6H109.046V9.0337ZM109.046 21.3822H112.678V10.6787H109.046V21.3822Z",
    fill: "#0D2259"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.545 10.6787H116.905L114.619 12.9647V19.0962L116.905 21.3822H122.545L124.831 19.0962V12.9647L122.545 10.6787ZM120.644 18.4766H118.807L118.251 17.9212V14.1397L118.807 13.5843H120.644L121.199 14.1397V17.9212L120.644 18.4766Z",
    fill: "#0D2259"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.835 10.6787H131.716L130.028 12.3665L129.986 10.6787H126.781V21.3822H130.413V14.567L131.396 13.5843H132.678L133.148 14.0543V21.3822H136.779V12.6229L134.835 10.6787Z",
    fill: "#0D2259"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmLogo);
export default __webpack_public_path__ + "static/media/adm-logo.4318ef50a2fc89613f0071ee538fb4a8.svg";
export { ForwardRef as ReactComponent };